// extracted by mini-css-extract-plugin
module.exports = {"questions":"_b4ec5435","buttons":"_41766dad","requestPrice":"_41358a54"};